import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, ShoppingBag } from "lucide-react";

const DraggableProductCard = ({ product, onClick, isDragging }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({ id: product.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`group relative rounded-xl cursor-pointer transition-all duration-300 border
        ${product.status === "available"
          ? "bg-green-500/10 hover:bg-green-500/20 border-green-500/20 hover:border-green-500/40"
          : "bg-red-500/10 hover:bg-red-500/20 border-red-500/20 hover:border-red-500/40"
        }
        ${isSortableDragging ? "shadow-2xl scale-105 z-50" : "hover:scale-105 hover:shadow-lg"}
      `}
    >
      {/* Drag Handle */}
      <div
        {...attributes}
        {...listeners}
        className="absolute top-1 left-1 z-10 p-1.5 bg-gray-800/80 rounded-lg cursor-grab active:cursor-grabbing opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <GripVertical className="w-4 h-4 text-yellow-400" />
      </div>

      {/* Card Content */}
      <div onClick={onClick} className="p-3">
        <div className="relative aspect-square mb-2">
          {product.image ? (
            <img
              src={product.image}
              alt={product.alt_text || "المنتج"}
              className="w-full h-full object-cover rounded-lg transition-transform group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-800 rounded-lg">
              <ShoppingBag className="w-8 h-8 text-gray-600" />
            </div>
          )}

          {/* Status Badge */}
          <div
            className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium border
              ${product.status === "available"
                ? "bg-green-500/20 text-green-400 border-green-500/30"
                : "bg-red-500/20 text-red-400 border-red-500/30"
              }`}
          >
            {product.status === "available" ? "متوفر" : "غير متوفر"}
          </div>
        </div>

        <h3 className="text-white text-sm font-medium truncate text-center group-hover:text-yellow-400 transition-colors">
          {product.name}
        </h3>
      </div>
    </div>
  );
};

export default DraggableProductCard;